import {Base} from "@/api/Base"

export class CurrencyDelete extends Base {
    path = "currency/delete"
}